// Action enums
export enum ActionTypes {
  ACCEPT_ALL_COOKIES = "ACCEPT_ALL_COOKIES",
  SET_PREFERENCES_COOKIE = "SET_PREFERENCES_COOKIE",
  SET_STATISTICS_COOKIE = "SET_STATISTICS_COOKIE",
  SET_MARKETING_COOKIE = "SET_MARKETING_COOKIE",
}
